import { AxiosError } from 'axios';
import { AUTH_SESSION_ERROR_CODE } from 'utils/constants';

/**
 * Returns whether the error means the current authenticated session is invalid.
 */
export default function isSessionAuthError(error: unknown): boolean {
  return (
    error instanceof AxiosError &&
    error.response?.status === 401 &&
    error.response?.data?.error?.code === AUTH_SESSION_ERROR_CODE
  );
}
